<div class="range-text">
  <label>{{ filterBase.label }}</label>
  <div class="range-inputs">
    <input [(ngModel)]="fromValue" (ngModelChange)="setValue('from',$event)" class="text-field" type="number" placeholder="מ־">
    <input [(ngModel)]="toValue" (ngModelChange)="setValue('to',$event)" class="text-field" type="number" placeholder="עד">
  </div>
</div>
